// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/dashboard_background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-container {
  display: flex;
  position: relative;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.9) 30%, rgba(0, 0, 0, 0.5) 60%, rgba(0, 0, 0, 0.1) 100%), 
              url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: right top;
  background-repeat: no-repeat;
  z-index: 1;
  text-align: left;
}

.timeline-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 66.67%; /* Covers two-thirds of the screen */
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.2; /* Highly faded */
  z-index: 1;
}

.vertical-timeline {
  position: relative;
  z-index: 2; /* Ensure this is above the background */
  width: 100%;
  padding: 20px;
}

.home-container {
  margin: 20px 0;
  text-align: center;
}

.home-logo-gif {
  max-width: 200px;
  margin-bottom: 10px;
}

.home-logo {
  padding: 20px;
  width: 100%;
  max-width: 400px;
}

.feature-card {
  cursor: pointer; /* Makes the card appear clickable */
  transition: transform 0.2s, box-shadow 0.2s; /* Smooth transition effect */
}

.feature-card:hover {
  transform: scale(1.02); /* Slightly enlarges the card on hover */
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Adds a shadow effect */
  background-color: rgba(37, 7, 32, 0.461);
}

.icon-container {
  flex-shrink: 0; /* Prevent the icon from shrinking */
  padding: 10px; /* Add some padding around the icon */
}

.feature-icon {
  width: 80px; /* Set a consistent width for icons */
  height: auto; /* Maintain aspect ratio */
}

.text-container {
  flex-grow: 1; /* Allow text to expand */
}

@media (max-width: 768px) {
  .feature-card {
    flex-direction: column; /* Stack items vertically on small screens */
    align-items: center; /* Center-align content for smaller screens */
  }

  .feature-icon {
    width: 40px; /* Adjust icon size for smaller screens */
    margin-bottom: 10px; /* Add spacing below the icon */
  }

  .home-logo-gif {
    max-width: 150px;
  }
  
  .crt-search-container {
    margin: 10px 0 20px;
  }
}

.masonry-grid {
  display: flex;
  width: 100%;
  margin-left: -15px;
}

.masonry-grid-column {
  padding-left: 15px;
  background-clip: padding-box;
}

.masonry-grid-column > div {
  margin-bottom: 15px;
}

.search-bar-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: 20px auto;
}

.search-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
}

.autocomplete-list {
  list-style: none;
  padding: 0;
  margin: 5px 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  position: absolute;
  width: 100%;
  z-index: 1000;
}

.autocomplete-list li {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.autocomplete-list li:hover {
  background: #f0f0f0;
}

.chat-response-card {
  margin-top: 20px;
  padding: 10px;
  border-radius: 10px;
  background: #f8f9fa;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.chat-input-container {
  display: flex;
  gap: 10px;
  margin: 20px 0;
}

.chat-input {
  border: 0px;
  flex-grow: 0;
  padding: 10px;
}

.send-btn {
  padding: 10px 16px;
}

.chat-messages {
  margin-top: 10px;
}

.chat-message {
  margin-bottom: 10px;
}

.chat-message.user {
  text-align: right;
}

.chat-message.assistant {
  text-align: left;
}

.cursor {
  animation: blink 1s step-start infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

/* Add styles for the circular checkboxes */
.circle-checkbox {
  position: relative;
  display: inline-block;
}

.custom-checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #007bff;
  outline: none;
  cursor: pointer;
  position: relative;
}

.custom-checkbox:checked {
  background-color: #007bff;
}

.custom-checkbox:checked:after {
  content: '✓';
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}


/* Add CSS for the CRT search container */
.crt-search-container {
  margin: 20px 0 30px;
}

.crt-search-container h4 {
  color: #fff;
  font-weight: 600;
}

/* Scoped select styling for homepage only */
.crt-search-container .dark-select__control {
  border-radius: 8px !important;
  border: 1px solid #ea3377 !important;
  box-shadow: none !important;
  min-height: 45px !important;
  padding: 10px;
  font-size: 16px;
  cursor: text !important;
}

.crt-search-container .dark-select__control:hover,
.crt-search-container .dark-select__control--is-focused {
  border-color: #80bdff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}

.crt-search-container .dark-select__menu {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  z-index: 100 !important;
}

/* Make all options show pointer cursor */
.crt-search-container .dark-select__option {
  cursor: pointer !important;
}

/* Strengthen hover styles */
.crt-search-container .dark-select__menu .dark-select__option:hover,
.crt-search-container .dark-select__menu .dark-select__option--is-focused {
  background-color: #ffeb3b !important; /* Yellow highlight */
  color: #000 !important; /* Black text for better contrast on yellow */
  cursor: pointer !important;
}

/* Selected option styles */
.crt-search-container .dark-select__menu .dark-select__option--is-selected,
.crt-search-container .dark-select__menu .dark-select__option--is-selected:hover {
  background-color: #ffc107 !important; /* Darker yellow for selected items */
  color: #000 !important;
  cursor: pointer !important;
}

/* Add direct hover effect */
.crt-search-container div[class*="dark-select__option"]:hover {
  background-color: #ffeb3b !important; 
  color: #000 !important;
  cursor: pointer !important;
}

/* Button styling */
.see-more-container {
  margin: 30px 0;
}

/* YouTube Videos Section */
.youtube-videos-section {
  margin: 30px 0;
}

.youtube-videos-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 20px 0;
}

.youtube-video-card {
  background: transparent;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.2s;
  text-decoration: none !important;
}

.youtube-video-card:hover {
  transform: translateY(-5px);
}

.youtube-video-card:hover .youtube-video-info {
  background: linear-gradient(to top, #4f013d, rgba(54, 0, 44, 0.8));
}

.youtube-thumbnail-wrapper {
  position: relative;
  width: 100%;
}

.youtube-thumbnail {
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  display: block;
}

.youtube-author-icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  position: absolute;
  top: 10px;
  right: 10px;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.youtube-video-info {
  padding: 12px;
  background: linear-gradient(to top, #4f013d, rgba(54, 0, 44, 0.8));
}

.youtube-video-title {
  font-size: 0.95rem;
  color: #fff;
  margin: 0 0 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  font-weight: 500;
}

.youtube-author-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.youtube-author-name {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  margin: 0;
}

@media (max-width: 768px) {
  .youtube-videos-container {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB;qDACqD;EACrD,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa,EAAE,oCAAoC;EACnD,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY,EAAE,iBAAiB;EAC/B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,wCAAwC;EACpD,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe,EAAE,oCAAoC;EACrD,2CAA2C,EAAE,6BAA6B;AAC5E;;AAEA;EACE,sBAAsB,EAAE,wCAAwC;EAChE,yCAAyC,EAAE,yBAAyB;EACpE,wCAAwC;AAC1C;;AAEA;EACE,cAAc,EAAE,oCAAoC;EACpD,aAAa,EAAE,qCAAqC;AACtD;;AAEA;EACE,WAAW,EAAE,qCAAqC;EAClD,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,YAAY,EAAE,yBAAyB;AACzC;;AAEA;EACE;IACE,sBAAsB,EAAE,4CAA4C;IACpE,mBAAmB,EAAE,6CAA6C;EACpE;;EAEA;IACE,WAAW,EAAE,yCAAyC;IACtD,mBAAmB,EAAE,+BAA+B;EACtD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;;;AAGA,yCAAyC;AACzC;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,gCAAgC;EAChC,2DAA2D;AAC7D;;AAEA;EACE,6BAA6B;EAC7B,qDAAqD;EACrD,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;;EAEE,oCAAoC,EAAE,qBAAqB;EAC3D,sBAAsB,EAAE,6CAA6C;EACrE,0BAA0B;AAC5B;;AAEA,2BAA2B;AAC3B;;EAEE,oCAAoC,EAAE,qCAAqC;EAC3E,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".timeline-container {\n  display: flex;\n  position: relative;\n  background: linear-gradient(to right, rgba(0, 0, 0, 0.9) 30%, rgba(0, 0, 0, 0.5) 60%, rgba(0, 0, 0, 0.1) 100%), \n              url('../assets/dashboard_background.png');\n  background-size: contain;\n  background-position: right top;\n  background-repeat: no-repeat;\n  z-index: 1;\n  text-align: left;\n}\n\n.timeline-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 66.67%; /* Covers two-thirds of the screen */\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n  opacity: 0.2; /* Highly faded */\n  z-index: 1;\n}\n\n.vertical-timeline {\n  position: relative;\n  z-index: 2; /* Ensure this is above the background */\n  width: 100%;\n  padding: 20px;\n}\n\n.home-container {\n  margin: 20px 0;\n  text-align: center;\n}\n\n.home-logo-gif {\n  max-width: 200px;\n  margin-bottom: 10px;\n}\n\n.home-logo {\n  padding: 20px;\n  width: 100%;\n  max-width: 400px;\n}\n\n.feature-card {\n  cursor: pointer; /* Makes the card appear clickable */\n  transition: transform 0.2s, box-shadow 0.2s; /* Smooth transition effect */\n}\n\n.feature-card:hover {\n  transform: scale(1.02); /* Slightly enlarges the card on hover */\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* Adds a shadow effect */\n  background-color: rgba(37, 7, 32, 0.461);\n}\n\n.icon-container {\n  flex-shrink: 0; /* Prevent the icon from shrinking */\n  padding: 10px; /* Add some padding around the icon */\n}\n\n.feature-icon {\n  width: 80px; /* Set a consistent width for icons */\n  height: auto; /* Maintain aspect ratio */\n}\n\n.text-container {\n  flex-grow: 1; /* Allow text to expand */\n}\n\n@media (max-width: 768px) {\n  .feature-card {\n    flex-direction: column; /* Stack items vertically on small screens */\n    align-items: center; /* Center-align content for smaller screens */\n  }\n\n  .feature-icon {\n    width: 40px; /* Adjust icon size for smaller screens */\n    margin-bottom: 10px; /* Add spacing below the icon */\n  }\n\n  .home-logo-gif {\n    max-width: 150px;\n  }\n  \n  .crt-search-container {\n    margin: 10px 0 20px;\n  }\n}\n\n.masonry-grid {\n  display: flex;\n  width: 100%;\n  margin-left: -15px;\n}\n\n.masonry-grid-column {\n  padding-left: 15px;\n  background-clip: padding-box;\n}\n\n.masonry-grid-column > div {\n  margin-bottom: 15px;\n}\n\n.search-bar-container {\n  position: relative;\n  width: 100%;\n  max-width: 500px;\n  margin: 20px auto;\n}\n\n.search-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.autocomplete-list {\n  list-style: none;\n  padding: 0;\n  margin: 5px 0;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  position: absolute;\n  width: 100%;\n  z-index: 1000;\n}\n\n.autocomplete-list li {\n  padding: 10px;\n  cursor: pointer;\n  border-bottom: 1px solid #eee;\n}\n\n.autocomplete-list li:hover {\n  background: #f0f0f0;\n}\n\n.chat-response-card {\n  margin-top: 20px;\n  padding: 10px;\n  border-radius: 10px;\n  background: #f8f9fa;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.chat-input-container {\n  display: flex;\n  gap: 10px;\n  margin: 20px 0;\n}\n\n.chat-input {\n  border: 0px;\n  flex-grow: 0;\n  padding: 10px;\n}\n\n.send-btn {\n  padding: 10px 16px;\n}\n\n.chat-messages {\n  margin-top: 10px;\n}\n\n.chat-message {\n  margin-bottom: 10px;\n}\n\n.chat-message.user {\n  text-align: right;\n}\n\n.chat-message.assistant {\n  text-align: left;\n}\n\n.cursor {\n  animation: blink 1s step-start infinite;\n}\n\n@keyframes blink {\n  50% {\n    opacity: 0;\n  }\n}\n\n/* Add styles for the circular checkboxes */\n.circle-checkbox {\n  position: relative;\n  display: inline-block;\n}\n\n.custom-checkbox {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid #007bff;\n  outline: none;\n  cursor: pointer;\n  position: relative;\n}\n\n.custom-checkbox:checked {\n  background-color: #007bff;\n}\n\n.custom-checkbox:checked:after {\n  content: '✓';\n  color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 14px;\n}\n\n\n/* Add CSS for the CRT search container */\n.crt-search-container {\n  margin: 20px 0 30px;\n}\n\n.crt-search-container h4 {\n  color: #fff;\n  font-weight: 600;\n}\n\n/* Scoped select styling for homepage only */\n.crt-search-container .dark-select__control {\n  border-radius: 8px !important;\n  border: 1px solid #ea3377 !important;\n  box-shadow: none !important;\n  min-height: 45px !important;\n  padding: 10px;\n  font-size: 16px;\n  cursor: text !important;\n}\n\n.crt-search-container .dark-select__control:hover,\n.crt-search-container .dark-select__control--is-focused {\n  border-color: #80bdff !important;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;\n}\n\n.crt-search-container .dark-select__menu {\n  border-radius: 8px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  z-index: 100 !important;\n}\n\n/* Make all options show pointer cursor */\n.crt-search-container .dark-select__option {\n  cursor: pointer !important;\n}\n\n/* Strengthen hover styles */\n.crt-search-container .dark-select__menu .dark-select__option:hover,\n.crt-search-container .dark-select__menu .dark-select__option--is-focused {\n  background-color: #ffeb3b !important; /* Yellow highlight */\n  color: #000 !important; /* Black text for better contrast on yellow */\n  cursor: pointer !important;\n}\n\n/* Selected option styles */\n.crt-search-container .dark-select__menu .dark-select__option--is-selected,\n.crt-search-container .dark-select__menu .dark-select__option--is-selected:hover {\n  background-color: #ffc107 !important; /* Darker yellow for selected items */\n  color: #000 !important;\n  cursor: pointer !important;\n}\n\n/* Add direct hover effect */\n.crt-search-container div[class*=\"dark-select__option\"]:hover {\n  background-color: #ffeb3b !important; \n  color: #000 !important;\n  cursor: pointer !important;\n}\n\n/* Button styling */\n.see-more-container {\n  margin: 30px 0;\n}\n\n/* YouTube Videos Section */\n.youtube-videos-section {\n  margin: 30px 0;\n}\n\n.youtube-videos-container {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin: 20px 0;\n}\n\n.youtube-video-card {\n  background: transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  transition: transform 0.2s;\n  text-decoration: none !important;\n}\n\n.youtube-video-card:hover {\n  transform: translateY(-5px);\n}\n\n.youtube-video-card:hover .youtube-video-info {\n  background: linear-gradient(to top, #4f013d, rgba(54, 0, 44, 0.8));\n}\n\n.youtube-thumbnail-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.youtube-thumbnail {\n  width: 100%;\n  aspect-ratio: 16/9;\n  object-fit: cover;\n  display: block;\n}\n\n.youtube-author-icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: 2px solid white;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.youtube-video-info {\n  padding: 12px;\n  background: linear-gradient(to top, #4f013d, rgba(54, 0, 44, 0.8));\n}\n\n.youtube-video-title {\n  font-size: 0.95rem;\n  color: #fff;\n  margin: 0 0 4px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n  font-weight: 500;\n}\n\n.youtube-author-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.youtube-author-name {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.85rem;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .youtube-videos-container {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
